"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcAccordionBehavior = void 0;
var tooltip_constants_1 = require("../bc-tooltip/tooltip-constants");
var common_constants_1 = require("../../../common/constants/common-constants");
var helpers_1 = require("../../../common/helpers");
var default_behavior_1 = require("./../../../common/models/default-behavior");
var bc_accordion_constants_1 = require("./bc-accordion-constants");
var bc_accordion_constants_2 = require("./bc-accordion-constants");
var bc_accordion_constants_3 = require("./bc-accordion-constants");
var bc_accordion_constants_4 = require("./bc-accordion-constants");
var bc_accordion_constants_5 = require("./bc-accordion-constants");
var bc_accordion_constants_6 = require("./bc-accordion-constants");
var bc_accordion_constants_7 = require("./bc-accordion-constants");
var bc_accordion_constants_8 = require("./bc-accordion-constants");
var bc_accordion_constants_9 = require("./bc-accordion-constants");
var bc_accordion_constants_10 = require("./bc-accordion-constants");
var BcAccordionBehavior = (function (_super) {
    __extends(BcAccordionBehavior, _super);
    function BcAccordionBehavior() {
        var _this = _super.call(this) || this;
        _this.headerList = [];
        _this.closeButtons = [];
        return _this;
    }
    BcAccordionBehavior.setUpAll = function () {
        var accordionsGroup = Array.from(document.querySelectorAll("div[class~='".concat(bc_accordion_constants_1.ACCORDIONS_GROUPS_SUFIX, "']")));
        var elements = [];
        for (var _i = 0, accordionsGroup_1 = accordionsGroup; _i < accordionsGroup_1.length; _i++) {
            var element = accordionsGroup_1[_i];
            var bcAccordionsBehavior = new BcAccordionBehavior();
            bcAccordionsBehavior.setElement(element);
            bcAccordionsBehavior.setUp();
            elements.push(bcAccordionsBehavior);
        }
        return elements;
    };
    BcAccordionBehavior.prototype._setUp = function () {
        this.headerList = [];
        this.getAccordionsGroup();
        var accordionList = this.getAccordions();
        var i = 0;
        for (var _i = 0, accordionList_1 = accordionList; _i < accordionList_1.length; _i++) {
            var accordion = accordionList_1[_i];
            this.setTabIndexIcon(accordion);
            this.addExpandEvent(accordion, i);
            this.setAccessibility();
            i++;
        }
    };
    BcAccordionBehavior.prototype.getHeader = function (accordion) {
        return accordion.querySelector(bc_accordion_constants_10.ACCORDION_HEADER);
    };
    BcAccordionBehavior.prototype.getContent = function (accordion) {
        return accordion.querySelector("section.".concat(bc_accordion_constants_9.ACCORDION_CONTENT_CLASS));
    };
    BcAccordionBehavior.prototype.setLabelTooltipText = function (accordion) {
        var tooltipText = accordion.querySelectorAll(".".concat(tooltip_constants_1.BC_TOOLTIP_SELECTOR));
        tooltipText.forEach(function (element) {
            if (tooltipText != null) {
                (0, helpers_1.addFocusable)(element, { tabindex: '0' });
                var attributte = element.getAttribute('bctooltiptext');
                element.setAttribute('aria-label', attributte);
            }
        });
    };
    BcAccordionBehavior.prototype.setTabIndexIcon = function (accordion) {
        var header = this.getHeader(accordion);
        var iconsFromHeaderLeft = Array.from(header.querySelectorAll("[class~='".concat(bc_accordion_constants_7.ACCORDION_HEADER_LEFT_CLASS, "'] .").concat(bc_accordion_constants_5.ACCORDION_TEXT_CONTAINER_CLASS, " .").concat(common_constants_1.BcCommonConstants.ICONS_CLASS)));
        var iconsFromHeaderRight = Array.from(header.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_8.ACCORDION_ACTION_CONTAINER_CLASS, " .").concat(common_constants_1.BcCommonConstants.ICONS_CLASS)));
        var labelFromHeaderRight = Array.from(header.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_LABEL)));
        var columnsFromHeaderRight = Array.from(header.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS)));
        var focusableElements = __spreadArray(__spreadArray(__spreadArray([], iconsFromHeaderRight, true), labelFromHeaderRight, true), columnsFromHeaderRight, true);
        iconsFromHeaderLeft.concat(focusableElements).forEach(function (element) {
            (0, helpers_1.addFocusable)(element, { tabindex: '0' });
        });
    };
    BcAccordionBehavior.prototype.getAccordionsGroup = function () {
        var accordionsGroup = Array.from(document.querySelectorAll("div[class~='".concat(bc_accordion_constants_1.ACCORDIONS_GROUPS_SUFIX, "']")));
        for (var _i = 0, accordionsGroup_2 = accordionsGroup; _i < accordionsGroup_2.length; _i++) {
            var accordion = accordionsGroup_2[_i];
            (0, helpers_1.addFocusable)(accordion, { role: 'group', tabindex: '-1' });
        }
        return accordionsGroup;
    };
    BcAccordionBehavior.prototype.getAccordions = function () {
        return Array.from(this.mySelf.querySelectorAll(":scope > article[class~='".concat(bc_accordion_constants_1.ACCORDION_CLASS, "'],:scope >*>*> article[class~='").concat(bc_accordion_constants_1.ACCORDION_CLASS, "']")));
    };
    BcAccordionBehavior.prototype.addExpandEvent = function (accordion, index) {
        var _this = this;
        if (accordion != null) {
            var content_1 = this.getContent(accordion);
            var header_1 = this.getHeader(accordion);
            this.setLabelTooltipText(accordion);
            var expand_1 = function () {
                var accordionsGroup = accordion.closest(".".concat(bc_accordion_constants_1.ACCORDIONS_GROUPS_SUFIX));
                var isSingle = accordionsGroup.classList.contains("".concat(bc_accordion_constants_2.ACCORDION_SINGLE_CLASS));
                var accordions = Array.from(accordionsGroup.querySelectorAll(":scope > [class~='".concat(bc_accordion_constants_1.ACCORDION_CLASS, "']")));
                for (var _i = 0, accordions_1 = accordions; _i < accordions_1.length; _i++) {
                    var element = accordions_1[_i];
                    if (element !== accordion && isSingle) {
                        element.classList.remove("".concat(bc_accordion_constants_3.ACCORDION_ACTIVE_CLASS));
                    }
                }
                var isIdMatched = accordion.id === header_1.getAttribute('aria-controls');
                if (isIdMatched) {
                    var isPresent = accordion.classList.toggle("".concat(bc_accordion_constants_3.ACCORDION_ACTIVE_CLASS));
                    if (isPresent && _this.activeFunction) {
                        _this.activeFunction(index);
                    }
                    header_1.setAttribute('aria-expanded', String(isPresent));
                    content_1.setAttribute('tabindex', isPresent ? '0' : '-1');
                }
            };
            var btnClose = header_1.querySelector(".".concat(bc_accordion_constants_4.ACCORDION_TOGGLE_BTN_CLASS));
            if (header_1 !== null && !this.closeButtons.includes(btnClose)) {
                btnClose.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, expand_1);
                this.closeButtons.push(btnClose);
                header_1.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
                    var currentEvnt = event.target;
                    if (!currentEvnt.classList.contains(common_constants_1.BcCommonConstants.ICONS_CLASS)) {
                        expand_1();
                    }
                });
            }
            var expandedValue = header_1.classList.contains(bc_accordion_constants_3.ACCORDION_ACTIVE_CLASS);
            (0, helpers_1.addFocusable)(header_1, { expanded: String(expandedValue), level: '1', tabindex: '0' }, { event: expand_1 });
        }
    };
    BcAccordionBehavior.prototype.getCurrentElement = function (index) {
        return this.mySelf.querySelectorAll(bc_accordion_constants_10.ACCORDION_HEADER)[index];
    };
    BcAccordionBehavior.prototype.getCurrentColumn = function (index) {
        return this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS))[index];
    };
    BcAccordionBehavior.prototype.getCurrentLabel = function (index) {
        return this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_LABEL))[index];
    };
    BcAccordionBehavior.prototype.setAccessibility = function () {
        var _this = this;
        this.mySelf.querySelectorAll(bc_accordion_constants_10.ACCORDION_HEADER).forEach(function (element, index) {
            _this.addScreenReader(element, index);
        });
        this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS)).forEach(function (element, index) {
            _this.addScreenReaderArrows(element, index);
        });
        this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_7.ACCORDION_HEADER_LEFT_CLASS, "'] .").concat('bc-tooltip')).forEach(function (element, index) {
            _this.addScreenReaderLabel(element, index);
        });
    };
    BcAccordionBehavior.prototype.addScreenReader = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_DOWN) {
                _this.focusNext(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_UP) {
                _this.focusBack(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_HOME) {
                _this.focusHomeEnd(index, true);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                _this.focusColumns(index);
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_END) {
                _this.focusHomeEnd(index);
            }
        });
    };
    BcAccordionBehavior.prototype.addScreenReaderLabel = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                _this.focusLabel(index);
            }
        });
    };
    BcAccordionBehavior.prototype.addScreenReaderArrows = function (element, index) {
        var _this = this;
        element.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_UP, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_RIGHT) {
                _this.focusRight(index);
                event.stopPropagation();
            }
            else if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ARROW_LEFT) {
                _this.focusLeft(index);
            }
        });
    };
    BcAccordionBehavior.prototype.focusHomeEnd = function (index, key) {
        if (key === void 0) { key = false; }
        var header = this.mySelf.querySelectorAll(bc_accordion_constants_10.ACCORDION_HEADER);
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (key) {
                index = 0;
            }
            else {
                index = header.length - 1;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcAccordionBehavior.prototype.focusNext = function (index) {
        var header = this.mySelf.querySelectorAll(bc_accordion_constants_10.ACCORDION_HEADER);
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index < header.length - 1) {
                index++;
            }
            else {
                index = 0;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcAccordionBehavior.prototype.focusBack = function (index) {
        var header = this.mySelf.querySelectorAll(bc_accordion_constants_10.ACCORDION_HEADER);
        if (this.getCurrentElement(index) !== null) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            else {
                index = header.length - 1;
            }
            this.getCurrentElement(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).focus();
        }
    };
    BcAccordionBehavior.prototype.focusRight = function (index) {
        var column = this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS));
        if (this.getCurrentColumn(index) !== null) {
            this.getCurrentColumn(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index < column.length - 1) {
                index++;
            }
            this.getCurrentColumn(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentColumn(index).focus();
        }
    };
    BcAccordionBehavior.prototype.focusLabel = function (index) {
        var label = this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_LABEL));
        if (label.length - 1 === index) {
            this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_7.ACCORDION_HEADER_LEFT_CLASS, "'] .").concat('bc-tooltip'))[index].classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentLabel(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentLabel(index).focus();
        }
    };
    BcAccordionBehavior.prototype.focusColumns = function (index) {
        var currentHeader = this.getCurrentElement(index).querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS));
        if (currentHeader.length) {
            this.getCurrentElement(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).querySelector("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS)).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentElement(index).querySelector("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS)).focus();
        }
    };
    BcAccordionBehavior.prototype.focusLeft = function (index) {
        var column = this.mySelf.querySelectorAll("[class~='".concat(bc_accordion_constants_6.ACCORDION_HEADER_RIGHT_CLASS, "'] .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CONTAINER_CLASS, " .").concat(bc_accordion_constants_1.ACCORDION_COLUMNS_CLASS));
        if (this.getCurrentColumn(index) !== null) {
            this.getCurrentColumn(index).classList.remove(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            if (index > 0) {
                index--;
            }
            this.getCurrentColumn(index).classList.add(common_constants_1.BcCommonConstants.OUTLINE_ELEMENT);
            this.getCurrentColumn(index).focus();
        }
    };
    return BcAccordionBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcAccordionBehavior = BcAccordionBehavior;
